import http from './httpServices';

const GhlIntegrationService = {
  getStatus: () => http.get('/integrations/ghl/status'),
  connect: ({ apiKey, locationId }) =>
    http.post('/integrations/ghl/connect', { apiKey, locationId }),
  disconnect: () => http.post('/integrations/ghl/disconnect'),
};

export default GhlIntegrationService;
